import React, {memo} from 'react';

const VismerKnappen = ({total, maxStep, renderedAmount, incrementer}) => {

    let numberOfElementerToRender = parseInt(renderedAmount)
    let step = parseInt(maxStep);
    if (total) {
        const gap = total - numberOfElementerToRender;
        if (gap < maxStep) {
            step = gap;
        }
    }

    const onClickHandler = (e) => {
        e.preventDefault();
        numberOfElementerToRender += step;
        incrementer(numberOfElementerToRender);
    }

    return total > numberOfElementerToRender
        ? (
            <button className="more-results link-button"
               onClick={onClickHandler}>
                Vis flere
            </button>
        )
        : null;
}

export default memo(VismerKnappen);
